import { TimeInput as MantineTimeInput } from "@mantine/dates";
import { IconClock } from "@tabler/icons-react";
import classNames from "classnames";
import { useRef } from "react";
import type { CSSProperties } from "react";
import { useDispatch } from "src/redux/hooks";
import { setTimeInputPopup } from "src/redux/slices/generatorFeaturesSlice";

// Reusing DateInput's styling since it acts mostly the same
import styles from "../DateInput/DateInput.module.scss";

interface TimeInputProps {
  id: string;
  value: string;
  placeholder?: string;
  readonly?: boolean;
  outline?: string;
  textStyle?: CSSProperties;
  className?: string;
  onChange: (value: string) => void;
  // Mantine styles overrides
  inputStyles?: CSSProperties;
  variant?: string;
}

export function TimeInput({
  id,
  value,
  placeholder,
  readonly,
  className,
  onChange,
  inputStyles,
  variant,
}: TimeInputProps) {
  const dispatch = useDispatch();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleOpenPopup = () => {
    if (readonly) return;
    if (inputRef.current) {
      const inputRect = inputRef.current.getBoundingClientRect();
      const spaceAbove = inputRect.top;
      const popupHeight = 250;

      let top = inputRect.bottom - 100; // bottom position
      // Check if there's enough space above the input
      if (spaceAbove > popupHeight + 100) {
        top = inputRect.top - popupHeight - 110;
      }

      dispatch(
        setTimeInputPopup({
          id,
          value,
          onChange,
          top,
          left: inputRect.left,
        }),
      );
    }
  };

  return (
    <MantineTimeInput
      ref={inputRef}
      id={id}
      onClick={handleOpenPopup}
      className={classNames(
        styles.input,
        readonly && styles.readonly,
        className,
      )}
      readOnly={!!readonly}
      variant={variant}
      placeholder={placeholder}
      rightSection={<IconClock size={16} />}
      styles={{
        input: {
          fontSize: "inherit",
          color: "inherit",
          ...(inputStyles as any),
        },
      }}
      value={value}
      onChange={e => onChange(e.target.value)}
    />
  );
}
